import http from '../app/httpService';

const apiEndpoint = process.env.REACT_APP_MARKET_DATA_API+"mark/";

export async function getMarks() {
    const {data: Marks} = await http.get(apiEndpoint);
    return Marks;
}

export async function getMark(markId) {
  const {data: Mark} = await http.get(apiEndpoint+markId);
  return Mark;
}

export async function getMarksByMarket(marketId, marketDate, organizationId) {
  const {data: Marks} = await http.get(apiEndpoint+"market/"+marketId+"/"+marketDate+"/"+organizationId);
  return Marks;
}

function buildAggregateMarksQueryString(options = {}) {
  const params = new URLSearchParams();

  Object.entries(options).forEach(([key, value]) => {
    if (value != null && value !== "") {
      params.append(key, value);
    }
  });

  const queryString = params.toString();
  return queryString ? "?" + queryString : "";
}

export async function getAggregateMarksByMarket(
  marketId,
  marketDate,
  toMarketDate = null,
  options = {}
) {
  const dateRangePath = toMarketDate ? "/" + toMarketDate : "";
  const {data: Marks} = await http.get(
    apiEndpoint+
      "aggregate/"+
      marketId+
      "/"+
      marketDate+
      dateRangePath+
      buildAggregateMarksQueryString(options)
  );
  return Marks;
}

export async function getInterpolatedAggregateMarksByMarket(
  marketId,
  marketDate,
  toMarketDate,
  options = {}
) {
  const {data: Marks} = await http.get(
    apiEndpoint+
      "aggregateinterpolated/"+
      marketId+
      "/"+
      marketDate+
      "/"+
      toMarketDate+
      buildAggregateMarksQueryString(options)
  );
  return Marks;
}

export async function getAggregateForwardMarksByMarket(marketId, marketDate, toMarketDate=null) {
  const {data: Marks} = await http.get(apiEndpoint+"aggregateforward/"+marketId+"/"+marketDate+"/"+(toMarketDate??""));
  return Marks;
}

export async function getAggregateForwardMarksAsOfByMarket(marketId, marketDate) {
  const {data: Marks} = await http.get(apiEndpoint+"aggregateforwardasof/"+marketId+"/"+marketDate);
  return Marks;
}

export async function getMarksForReview(marketDate) {
  const {data: Marks} = await http.get(apiEndpoint+"review/"+marketDate);
  return Marks;
}

export async function addMark(mark) {  
  const {data: Mark} = await http.post(apiEndpoint, mark);
  return Mark;
}

export async function updateMark(mark) {
  const {data: Mark} = await http.put(apiEndpoint, mark);
  return Mark;
}

export async function approveMark(updateMarkStatus) {
  const {data: NumOfMarksApproved} = await http.put(apiEndpoint+"approve", updateMarkStatus);
  return NumOfMarksApproved;
}

export async function rejectMark(updateMarkStatus) {
  const {data: NumOfMarksApproved} = await http.put(apiEndpoint+"reject", updateMarkStatus);
  return NumOfMarksApproved;
}

export async function deleteMark(mark) {
  const {data: Mark} = await http.put(apiEndpoint+"delete", mark);
  return Mark;
}

export async function getMarkHistory(markId) {
  const {data: MarkHistory} = await http.get(apiEndpoint+"audit/"+markId);
  return MarkHistory;
}

export async function getUnapprovedMarkCount() {
  const {data: UnapprovedMarkCount} = await http.get(apiEndpoint+"GetUnapprovedCount");
  return UnapprovedMarkCount;
}
